import React from "react"

export const MermaidAblauf = () => {
  return (
    <div className="mermaid" data-processed="true">
      <svg
        id="mermaid-1633517036752"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        height={1750}
        viewBox="0 0 924.5390625 1750"
        style={{ maxWidth: "924.539px" }}
      >
        <style
          dangerouslySetInnerHTML={{
            __html:
              "#mermaid-1633517036752 {font-family:Lato;font-size:16px;fill:#000000;}#mermaid-1633517036752 .error-icon{fill:#552222;}#mermaid-1633517036752 .error-text{fill:#552222;stroke:#552222;}#mermaid-1633517036752 .edge-thickness-normal{stroke-width:2px;}#mermaid-1633517036752 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1633517036752 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1633517036752 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1633517036752 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1633517036752 .marker{fill:#666;stroke:#666;}#mermaid-1633517036752 .marker.cross{stroke:#666;}#mermaid-1633517036752 svg{font-family:Lato;font-size:16px;}#mermaid-1633517036752 .label{font-family:Lato;color:#000000;}#mermaid-1633517036752 .cluster-label text{fill:#333;}#mermaid-1633517036752 .cluster-label span{color:#333;}#mermaid-1633517036752 .label text,#mermaid-1633517036752 span{fill:#000000;color:#000000;}#mermaid-1633517036752 .node rect,#mermaid-1633517036752 .node circle,#mermaid-1633517036752 .node ellipse,#mermaid-1633517036752 .node polygon,#mermaid-1633517036752 .node path{fill:#eee;stroke:#999;stroke-width:1px;}#mermaid-1633517036752 .node .label{text-align:center;}#mermaid-1633517036752 .node.clickable{cursor:pointer;}#mermaid-1633517036752 .arrowheadPath{fill:#333333;}#mermaid-1633517036752 .edgePath .path{stroke:#666;stroke-width:2.0px;}#mermaid-1633517036752 .flowchart-link{stroke:#666;fill:none;}#mermaid-1633517036752 .edgeLabel{background-color:white;text-align:center;}#mermaid-1633517036752 .edgeLabel rect{opacity:0.5;background-color:white;fill:white;}#mermaid-1633517036752 .cluster rect{fill:hsl(0, 0%, 98.9215686275%);stroke:#707070;stroke-width:1px;}#mermaid-1633517036752 .cluster text{fill:#333;}#mermaid-1633517036752 .cluster span{color:#333;}#mermaid-1633517036752 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:Lato;font-size:12px;background:hsl(-160, 0%, 93.3333333333%);border:1px solid #707070;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1633517036752 :root{--mermaid-font-family:Lato;}",
          }}
        />
        <g transform="translate(0, 0)">
          <marker
            id="flowchart-pointEnd"
            className="marker flowchart"
            viewBox="0 0 10 10"
            refX={9}
            refY={5}
            markerUnits="userSpaceOnUse"
            markerWidth={12}
            markerHeight={12}
            orient="auto"
          >
            <path
              d="M 0 0 L 10 5 L 0 10 z"
              className="arrowMarkerPath"
              style={{ strokeWidth: 1, strokeDasharray: "1, 0" }}
            />
          </marker>
          <marker
            id="flowchart-pointStart"
            className="marker flowchart"
            viewBox="0 0 10 10"
            refX={0}
            refY={5}
            markerUnits="userSpaceOnUse"
            markerWidth={12}
            markerHeight={12}
            orient="auto"
          >
            <path
              d="M 0 5 L 10 10 L 10 0 z"
              className="arrowMarkerPath"
              style={{ strokeWidth: 1, strokeDasharray: "1, 0" }}
            />
          </marker>
          <marker
            id="flowchart-circleEnd"
            className="marker flowchart"
            viewBox="0 0 10 10"
            refX={11}
            refY={5}
            markerUnits="userSpaceOnUse"
            markerWidth={11}
            markerHeight={11}
            orient="auto"
          >
            <circle
              cx={5}
              cy={5}
              r={5}
              className="arrowMarkerPath"
              style={{ strokeWidth: 1, strokeDasharray: "1, 0" }}
            />
          </marker>
          <marker
            id="flowchart-circleStart"
            className="marker flowchart"
            viewBox="0 0 10 10"
            refX={-1}
            refY={5}
            markerUnits="userSpaceOnUse"
            markerWidth={11}
            markerHeight={11}
            orient="auto"
          >
            <circle
              cx={5}
              cy={5}
              r={5}
              className="arrowMarkerPath"
              style={{ strokeWidth: 1, strokeDasharray: "1, 0" }}
            />
          </marker>
          <marker
            id="flowchart-crossEnd"
            className="marker cross flowchart"
            viewBox="0 0 11 11"
            refX={12}
            refY="5.2"
            markerUnits="userSpaceOnUse"
            markerWidth={11}
            markerHeight={11}
            orient="auto"
          >
            <path
              d="M 1,1 l 9,9 M 10,1 l -9,9"
              className="arrowMarkerPath"
              style={{ strokeWidth: 2, strokeDasharray: "1, 0" }}
            />
          </marker>
          <marker
            id="flowchart-crossStart"
            className="marker cross flowchart"
            viewBox="0 0 11 11"
            refX={-1}
            refY="5.2"
            markerUnits="userSpaceOnUse"
            markerWidth={11}
            markerHeight={11}
            orient="auto"
          >
            <path
              d="M 1,1 l 9,9 M 10,1 l -9,9"
              className="arrowMarkerPath"
              style={{ strokeWidth: 2, strokeDasharray: "1, 0" }}
            />
          </marker>
          <g className="root">
            <g className="clusters">
              <g className="cluster default" id="Angebotsphase">
                <rect
                  rx={0}
                  ry={0}
                  x="22.44921875"
                  y={736}
                  width="729.75"
                  height={595}
                />
                <g
                  className="cluster-label"
                  transform="translate(338.44140625, 741)"
                >
                  <foreignObject width="97.765625" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Angebotsphase</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
            </g>
            <g className="edgePaths">
              <path
                d="M477.9142050638686,1154L497.8184781782238,1145.3333333333333C517.7227512925791,1136.6666666666667,557.5312975212895,1119.3333333333333,577.4355706356447,1099.25C597.33984375,1079.1666666666667,597.33984375,1056.3333333333333,597.33984375,1035C597.33984375,1013.6666666666666,597.33984375,993.8333333333334,597.33984375,974C597.33984375,954.1666666666666,597.33984375,934.3333333333334,597.33984375,913C597.33984375,891.6666666666666,597.33984375,868.8333333333334,577.4355706356447,848.75C557.5312975212895,828.6666666666666,517.7227512925791,811.3333333333334,497.8184781782238,802.6666666666666L477.9142050638686,794"
                id="L-Angebotsbewertung-Angebotsabgabe-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsbewertung LE-Angebotsabgabe"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M391.9309135492701,794L366.6722456660584,802.6666666666666C341.41357778284674,811.3333333333334,290.8962420164234,828.6666666666666,265.6375741332117,846C240.37890625,863.3333333333334,240.37890625,880.6666666666666,240.37890625,889.3333333333334L240.37890625,898"
                id="L-Angebotsabgabe-Angebotseröffnung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsabgabe LE-Angebotseröffnung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M240.37890625,931L240.37890625,938.1666666666666C240.37890625,945.3333333333334,240.37890625,959.6666666666666,240.37890625,974C240.37890625,988.3333333333334,240.37890625,1002.6666666666666,240.37890625,1009.8333333333334L240.37890625,1017"
                id="L-Angebotseröffnung-Angebotsprüfung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotseröffnung LE-Angebotsprüfung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M240.37890625,1050L240.37890625,1058.6666666666667C240.37890625,1067.3333333333333,240.37890625,1084.6666666666667,265.6375741332117,1102C290.8962420164234,1119.3333333333333,341.41357778284674,1136.6666666666667,366.6722456660584,1145.3333333333333L391.9309135492701,1154"
                id="L-Angebotsprüfung-Angebotsbewertung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsprüfung LE-Angebotsbewertung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M369.04418329831935,1187L338.2165069152661,1194.1666666666667C307.3888305322129,1201.3333333333333,245.73347776610646,1215.6666666666667,248.68314513305322,1231.102056614488C251.6328125,1246.5374465623092,319.1875,1263.0748931246183,352.96484375,1271.343616405773L386.7421875,1279.6123396869275"
                id="L-Angebotsbewertung-Abschluss-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsbewertung LE-Abschluss"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M436.44590336134456,1187L434.8937215511205,1194.1666666666667C433.3415397408964,1201.3333333333333,430.23717612044817,1215.6666666666667,428.6849943102241,1230C427.1328125,1244.3333333333333,427.1328125,1258.6666666666667,427.1328125,1265.8333333333333L427.1328125,1273"
                id="L-Angebotsbewertung-Abschluss-1"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsbewertung LE-Abschluss"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M501.0918461134454,1187L527.6182050945378,1194.1666666666667C554.1445640756302,1201.3333333333333,607.1972820378152,1215.6666666666667,601.6025472689075,1231.0318068076456C596.0078125,1246.3969469486244,531.765625,1262.7938938972486,499.64453125,1270.9923673715607L467.5234375,1279.1908408458728"
                id="L-Angebotsbewertung-Abschluss-2"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Angebotsbewertung LE-Abschluss"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M386.7421875,1294.9203824874314L341.93359375,1300.9336520728596C297.125,1306.9469216582877,207.5078125,1318.9734608291437,162.69921875,1333.6533970812386C117.890625,1348.3333333333333,117.890625,1365.6666666666667,117.890625,1383C117.890625,1400.3333333333333,117.890625,1417.6666666666667,117.890625,1426.3333333333333L117.890625,1435"
                id="L-Abschluss-Verfahrensaufhebung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Abschluss LE-Verfahrensaufhebung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M467.5234375,1295.9064436183396L504.3990885416667,1301.7553696819498C541.2747395833334,1307.6042957455597,615.0260416666666,1319.3021478727799,651.9016927083334,1333.8177406030566C688.77734375,1348.3333333333333,688.77734375,1365.6666666666667,688.77734375,1383C688.77734375,1400.3333333333333,688.77734375,1417.6666666666667,688.77734375,1426.3333333333333L688.77734375,1435"
                id="L-Abschluss-Zuschlagserteilung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Abschluss LE-Zuschlagserteilung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M688.77734375,1468L688.77734375,1476.6666666666667C688.77734375,1485.3333333333333,688.77734375,1502.6666666666667,688.77734375,1520C688.77734375,1537.3333333333333,688.77734375,1554.6666666666667,688.77734375,1563.3333333333333L688.77734375,1572"
                id="L-Zuschlagserteilung-Vorabinformation-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Zuschlagserteilung LE-Vorabinformation"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M688.77734375,1605L688.77734375,1613.6666666666667C688.77734375,1622.3333333333333,688.77734375,1639.6666666666667,699.1950368765207,1657C709.6127300030413,1674.3333333333333,730.4481162560827,1691.6666666666667,740.8658093826034,1700.3333333333333L751.2835025091241,1709"
                id="L-Vorabinformation-Vertragsabschluss-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Vorabinformation LE-Vertragsabschluss"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M676.4296875,35.552570634553035L705.3046875,40.62714219546086C734.1796875,45.70171375636869,791.9296875,55.850856878184345,820.8046875,113.17542843909217C849.6796875,170.5,849.6796875,275,849.6796875,381C849.6796875,487,849.6796875,594.5,849.6796875,653.9166666666666C849.6796875,713.3333333333334,849.6796875,724.6666666666666,849.6796875,737.25C849.6796875,749.8333333333334,849.6796875,763.6666666666666,849.6796875,782C849.6796875,800.3333333333334,849.6796875,823.1666666666666,849.6796875,846C849.6796875,868.8333333333334,849.6796875,891.6666666666666,849.6796875,913C849.6796875,934.3333333333334,849.6796875,954.1666666666666,849.6796875,974C849.6796875,993.8333333333334,849.6796875,1013.6666666666666,849.6796875,1035C849.6796875,1056.3333333333333,849.6796875,1079.1666666666667,849.6796875,1102C849.6796875,1124.8333333333333,849.6796875,1147.6666666666667,849.6796875,1169C849.6796875,1190.3333333333333,849.6796875,1210.1666666666667,849.6796875,1230C849.6796875,1249.8333333333333,849.6796875,1269.6666666666667,849.6796875,1286.5C849.6796875,1303.3333333333333,849.6796875,1317.1666666666667,849.6796875,1332.75C849.6796875,1348.3333333333333,849.6796875,1365.6666666666667,849.6796875,1385.75C849.6796875,1405.8333333333333,849.6796875,1428.6666666666667,849.6796875,1451.5C849.6796875,1474.3333333333333,849.6796875,1497.1666666666667,849.6796875,1520C849.6796875,1542.8333333333333,849.6796875,1565.6666666666667,849.6796875,1588.5C849.6796875,1611.3333333333333,849.6796875,1634.1666666666667,839.7399064781022,1654.25C829.8001254562045,1674.3333333333333,809.9205634124088,1691.6666666666667,799.9807823905109,1700.3333333333333L790.0410013686131,1709"
                id="L-Start-Vertragsabschluss-0"
                className="edge-thickness-thick edge-pattern-solid flowchart-link LS-Start LE-Vertragsabschluss"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ strokeWidth: "3.5px", fill: "none" }}
              />
              <path
                d="M550.6484375,39.541309290650815L532.2102864583334,43.951091075542344C513.7721354166666,48.36087286043388,476.8958333333333,57.180436430216936,458.4576822916667,65.75688488177514C440.01953125,74.33333333333333,440.01953125,82.66666666666667,440.01953125,86.83333333333333L440.01953125,91"
                id="L-Start-Vorbereitung-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Start LE-Vorbereitung"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
              <path
                d="M440.01953125,668L440.01953125,673.6666666666666C440.01953125,679.3333333333334,440.01953125,690.6666666666666,440.01953125,702C440.01953125,713.3333333333334,440.01953125,724.6666666666666,440.01953125,730.3333333333334L440.01953125,736"
                id="L-Vorbereitung-Angebotsphase-0"
                className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Vorbereitung LE-Angebotsphase"
                markerEnd="url(#flowchart-pointEnd)"
                style={{ fill: "none" }}
              />
            </g>
            <g className="edgeLabels">
              <g className="edgeLabel" transform="translate(597.33984375, 974)">
                <g className="label" transform="translate(-109.7265625, -18)">
                  <foreignObject width="219.453125" height={36}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        fehlende Nachweise können auf
                        <br /> Anforderung nachgereicht werden
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(240.37890625, 846)">
                <g className="label" transform="translate(-165.5078125, -27)">
                  <foreignObject width="331.015625" height={54}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Angebot inklusive gewünschter Referenzen,
                        <br /> Nachweise und Erklärungen postalisch, direkt oder
                        <br /> elektronisch bis zur angegeben Abgabefrist
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(240.37890625, 974)">
                <g className="label" transform="translate(-125.96875, -18)">
                  <foreignObject width="251.9375" height={36}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Angebote müssen bis zur Öffnung
                        <br />
                        verschlossen oder verschlüsselt bleiben
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="edgeLabel"
                transform="translate(240.37890625, 1102)"
              >
                <g className="label" transform="translate(-54.875, -9)">
                  <foreignObject width="109.75" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">formelle Prüfung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(184.078125, 1230)">
                <g className="label" transform="translate(-117.75, -18)">
                  <foreignObject width="235.5" height={36}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Auschluss von Bietern bei
                        <br /> nicht bestandender Eignungsprüfung
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(427.1328125, 1230)">
                <g className="label" transform="translate(-105.3046875, -18)">
                  <foreignObject width="210.609375" height={36}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Ausschluss bei fehlenden
                        <br /> Qualifikationen und Nachweisen
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(660.25, 1230)">
                <g className="label" transform="translate(-57.4375, -18)">
                  <foreignObject width="114.875" height={36}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Prüfung der
                        <br /> Wirtschaftlichkeit
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(117.890625, 1383)">
                <g className="label" transform="translate(-109.890625, -27)">
                  <foreignObject width="219.78125" height={54}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        wenn nicht genügend
                        <br /> oder den Vorgaben entsprechende
                        <br /> Angebote eingereicht werden
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="edgeLabel"
                transform="translate(688.77734375, 1383)"
              >
                <g className="label" transform="translate(-137.5078125, -9)">
                  <foreignObject width="275.015625" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        wirtschaftlichste Angebote erhält Zuschlag
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="edgeLabel"
                transform="translate(688.77734375, 1520)"
              >
                <g className="label" transform="translate(-106.6328125, -27)">
                  <foreignObject width="213.265625" height={54}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Vor Vertragsabschluss müssen
                        <br /> nicht berücksichtigte Bieter über
                        <br /> Wahl informiert werden
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="edgeLabel"
                transform="translate(688.77734375, 1657)"
              >
                <g className="label" transform="translate(-119.3203125, -27)">
                  <foreignObject width="238.640625" height={54}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        nach Versand der Information
                        <br /> muss Frist für den Vertragsabschluss
                        <br /> eingehalten werden
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(849.6796875, 1102)">
                <g className="label" transform="translate(-66.859375, -27)">
                  <foreignObject width="133.71875" height={54}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Dokumentation
                        <br /> während des
                        <br /> gesamten Verfahrens
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel">
                <g className="label" transform="translate(0, 0)">
                  <foreignObject width={0} height={0}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel" />
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="edgeLabel" transform="translate(440.01953125, 702)">
                <g className="label" transform="translate(-184.234375, -9)">
                  <foreignObject width="368.46875" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="edgeLabel">
                        Angebotserstellung auf Grundlage der Vergabeunterlagen
                      </span>
                    </div>
                  </foreignObject>
                </g>
              </g>
            </g>
            <g className="nodes">
              <g
                className="node default default"
                id="flowchart-Angebotsabgabe-47"
                transform="translate(440.01953125, 777.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-60.8203125"
                  y="-16.5"
                  width="121.640625"
                  height={33}
                />
                <g className="label" transform="translate(-53.3203125, -9)">
                  <foreignObject width="106.640625" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Angebotsabgabe</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Angebotsbewertung-46"
                transform="translate(440.01953125, 1170.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-71.9296875"
                  y="-16.5"
                  width="143.859375"
                  height={33}
                />
                <g className="label" transform="translate(-64.4296875, -9)">
                  <foreignObject width="128.859375" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Angebotsbewertung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Angebotseröffnung-49"
                transform="translate(240.37890625, 914.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-69.5625"
                  y="-16.5"
                  width="139.125"
                  height={33}
                />
                <g className="label" transform="translate(-62.0625, -9)">
                  <foreignObject width="124.125" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Angebotseröffnung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Angebotsprüfung-51"
                transform="translate(240.37890625, 1033.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-63.4921875"
                  y="-16.5"
                  width="126.984375"
                  height={33}
                />
                <g className="label" transform="translate(-55.9921875, -9)">
                  <foreignObject width="111.984375" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Angebotsprüfung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Abschluss-55"
                transform="translate(427.1328125, 1289.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-40.390625"
                  y="-16.5"
                  width="80.78125"
                  height={33}
                />
                <g className="label" transform="translate(-32.890625, -9)">
                  <foreignObject width="65.78125" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Abschluss</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g className="root" transform="translate(229.69140625, 83)">
                <g className="clusters">
                  <g className="cluster default" id="Vorbereitung">
                    <rect
                      rx={0}
                      ry={0}
                      x={8}
                      y={8}
                      width="405.65625"
                      height={577}
                    />
                    <g
                      className="cluster-label"
                      transform="translate(169.203125, 13)"
                    >
                      <foreignObject width="83.25" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">Vorbereitung</span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                </g>
                <g className="edgePaths">
                  <path
                    d="M210.828125,66L210.828125,74.66666666666667C210.828125,83.33333333333333,210.828125,100.66666666666667,210.828125,118C210.828125,135.33333333333334,210.828125,152.66666666666666,210.828125,161.33333333333334L210.828125,170"
                    id="L-Bedarfsermittlung-Vergabeunterlagen-0"
                    className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Bedarfsermittlung LE-Vergabeunterlagen"
                    markerEnd="url(#flowchart-pointEnd)"
                    style={{ fill: "none" }}
                  />
                  <path
                    d="M210.828125,203L210.828125,211.66666666666666C210.828125,220.33333333333334,210.828125,237.66666666666666,210.828125,255C210.828125,272.3333333333333,210.828125,289.6666666666667,210.828125,298.3333333333333L210.828125,307"
                    id="L-Vergabeunterlagen-AuswahlderVergabeart-0"
                    className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Vergabeunterlagen LE-AuswahlderVergabeart"
                    markerEnd="url(#flowchart-pointEnd)"
                    style={{ fill: "none" }}
                  />
                  <path
                    d="M210.828125,340L210.828125,347.1666666666667C210.828125,354.3333333333333,210.828125,368.6666666666667,210.828125,383C210.828125,397.3333333333333,210.828125,411.6666666666667,210.828125,418.8333333333333L210.828125,426"
                    id="L-AuswahlderVergabeart-Bekanntmachung-0"
                    className="edge-thickness-normal edge-pattern-solid flowchart-link LS-AuswahlderVergabeart LE-Bekanntmachung"
                    markerEnd="url(#flowchart-pointEnd)"
                    style={{ fill: "none" }}
                  />
                  <path
                    d="M210.828125,459L210.828125,464.6666666666667C210.828125,470.3333333333333,210.828125,481.6666666666667,210.828125,493C210.828125,504.3333333333333,210.828125,515.6666666666666,210.828125,521.3333333333334L210.828125,527"
                    id="L-Bekanntmachung-Angebotserstellung-0"
                    className="edge-thickness-normal edge-pattern-solid flowchart-link LS-Bekanntmachung LE-Angebotserstellung"
                    markerEnd="url(#flowchart-pointEnd)"
                    style={{ fill: "none" }}
                  />
                </g>
                <g className="edgeLabels">
                  <g
                    className="edgeLabel"
                    transform="translate(210.828125, 118)"
                  >
                    <g
                      className="label"
                      transform="translate(-182.828125, -27)"
                    >
                      <foreignObject width="365.65625" height={54}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="edgeLabel">
                            Definition des Beschaffungsgegenstands,
                            <br /> Auftragswerts &amp;
                            <br /> Überlegungen zur Bieterauswahl und
                            Zuschlagskriterien
                            <br />
                          </span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="edgeLabel"
                    transform="translate(210.828125, 255)"
                  >
                    <g
                      className="label"
                      transform="translate(-96.1796875, -27)"
                    >
                      <foreignObject width="192.359375" height={54}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="edgeLabel">
                            Leistungsbeschreibung,
                            <br /> Vertragsbedingungen &amp;
                            <br /> weiterführende Informationen
                          </span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="edgeLabel"
                    transform="translate(210.828125, 383)"
                  >
                    <g
                      className="label"
                      transform="translate(-96.6328125, -18)"
                    >
                      <foreignObject width="193.265625" height={36}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="edgeLabel">
                            Keine freie Auswahl,
                            <br />
                            richtet sich nach Auftragswert
                          </span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="edgeLabel"
                    transform="translate(210.828125, 493)"
                  >
                    <g className="label" transform="translate(-87.3203125, -9)">
                      <foreignObject width="174.640625" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="edgeLabel">
                            Online oder in Printmedien
                          </span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                </g>
                <g className="nodes">
                  <g
                    className="node default default"
                    id="flowchart-Vergabeunterlagen-39"
                    transform="translate(210.828125, 186.5)"
                  >
                    <rect
                      className="basic label-container"
                      rx={0}
                      ry={0}
                      x="-67.328125"
                      y="-16.5"
                      width="134.65625"
                      height={33}
                    />
                    <g className="label" transform="translate(-59.828125, -9)">
                      <foreignObject width="119.65625" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">Vergabeunterlagen</span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="node default default"
                    id="flowchart-Bedarfsermittlung-38"
                    transform="translate(210.828125, 49.5)"
                  >
                    <rect
                      className="basic label-container"
                      rx={0}
                      ry={0}
                      x="-65.7109375"
                      y="-16.5"
                      width="131.421875"
                      height={33}
                    />
                    <g className="label" transform="translate(-58.2109375, -9)">
                      <foreignObject width="116.421875" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">Bedarfsermittlung</span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="node default default"
                    id="flowchart-AuswahlderVergabeart-41"
                    transform="translate(210.828125, 323.5)"
                  >
                    <rect
                      className="basic label-container"
                      rx={0}
                      ry={0}
                      x="-84.65625"
                      y="-16.5"
                      width="169.3125"
                      height={33}
                    />
                    <g className="label" transform="translate(-77.15625, -9)">
                      <foreignObject width="154.3125" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">
                            Auswahl der Vergabeart
                          </span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="node default default"
                    id="flowchart-Bekanntmachung-43"
                    transform="translate(210.828125, 442.5)"
                  >
                    <rect
                      className="basic label-container"
                      rx={0}
                      ry={0}
                      x="-63.484375"
                      y="-16.5"
                      width="126.96875"
                      height={33}
                    />
                    <g className="label" transform="translate(-55.984375, -9)">
                      <foreignObject width="111.96875" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">Bekanntmachung</span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                  <g
                    className="node default default"
                    id="flowchart-Angebotserstellung-45"
                    transform="translate(210.828125, 543.5)"
                  >
                    <rect
                      className="basic label-container"
                      rx={0}
                      ry={0}
                      x="-69.7109375"
                      y="-16.5"
                      width="139.421875"
                      height={33}
                    />
                    <g className="label" transform="translate(-62.2109375, -9)">
                      <foreignObject width="124.421875" height={18}>
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="nodeLabel">Angebotserstellung</span>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Start-36"
                transform="translate(613.5390625, 24.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-62.890625"
                  y="-16.5"
                  width="125.78125"
                  height={33}
                />
                <g className="label" transform="translate(-55.390625, -9)">
                  <foreignObject width="110.78125" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Start der Vergabe</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Verfahrensaufhebung-61"
                transform="translate(117.890625, 1451.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-75.9140625"
                  y="-16.5"
                  width="151.828125"
                  height={33}
                />
                <g className="label" transform="translate(-68.4140625, -9)">
                  <foreignObject width="136.828125" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Verfahrensaufhebung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Zuschlagserteilung-63"
                transform="translate(688.77734375, 1451.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-68.375"
                  y="-16.5"
                  width="136.75"
                  height={33}
                />
                <g className="label" transform="translate(-60.875, -9)">
                  <foreignObject width="121.75" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Zuschlagserteilung</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Vorabinformation-65"
                transform="translate(688.77734375, 1588.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-64.234375"
                  y="-16.5"
                  width="128.46875"
                  height={33}
                />
                <g className="label" transform="translate(-56.734375, -9)">
                  <foreignObject width="113.46875" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Vorabinformation</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
              <g
                className="node default default"
                id="flowchart-Vertragsabschluss-67"
                transform="translate(771.1171875, 1725.5)"
              >
                <rect
                  className="basic label-container"
                  rx={0}
                  ry={0}
                  x="-64.8203125"
                  y="-16.5"
                  width="129.640625"
                  height={33}
                />
                <g className="label" transform="translate(-57.3203125, -9)">
                  <foreignObject width="114.640625" height={18}>
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{ display: "inline-block", whiteSpace: "nowrap" }}
                    >
                      <span className="nodeLabel">Vertragsabschluss</span>
                    </div>
                  </foreignObject>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
